import { connect } from 'react-redux';
import React, { Component } from 'react';

import { closeModalPurchaseDateError } from '../../../actions/purchaseActions';


export class ModalPurchaseDateError extends Component {
  constructor(props) {
    super(props);

    this.goToSearchPage = this.goToSearchPage.bind(this);
  }

  goToSearchPage() {
   window.history.go(-1);
  }

  render() {
    if (!this.props.isModalPurchaseErrorDate) return <div />;

    return (
      <div className="comp_modalpagamento">
        <div className="modalcontents contents-purchase-error">
          <div className="contents">
            <div className="modaltop purchase-error">
              <div className="title">Horário de compra indisponível</div>

              <div onClick={this.props.closeModalPurchaseDateError} className="close-btn">
                {' '}
                &times;{' '}
              </div>
            </div>

            <div className="modalmiddle purchase-error">
              <p>
                <img src="/assets/images/calendar-error.svg" alt="erro" />
              </p>
              <p>
                <strong>
                  Compras de seguro viagem com inicio vigência na data de hoje hoje só podem ser feitas até as 23h30.
                </strong>
              </p>
              <p>
                <b>Por favor, volte à tela inicial para ajustar sua escolha.</b>
              </p>
            </div>

            <div className="modalbotton purchase-error">
              <button className="button full" onClick={this.goToSearchPage}>
                <span>Voltar à tela inicial</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    isModalPurchaseErrorDate: state.purchase.isModalPurchaseErrorDate,
  }),
  {
    closeModalPurchaseDateError,
  }
)(ModalPurchaseDateError);



// WEBPACK FOOTER //
// ./src/components/purchase/modal_purchase_date_error/ModalPurchaseDateError.jsx